import LoginWidget from "../widgets/LoginWidget";

function LoginPage(){
    return(
        <div style={{padding: '2em', textAlign:'center'}}>
            <LoginWidget></LoginWidget>
        </div>
    )
}

export default LoginPage;